import { render, staticRenderFns } from "./LanguageListing.vue?vue&type=template&id=30fdc3fa"
import script from "./LanguageListing.vue?vue&type=script&lang=js"
export * from "./LanguageListing.vue?vue&type=script&lang=js"
import style0 from "./LanguageListing.vue?vue&type=style&index=0&id=30fdc3fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports